import { Jed } from 'jed'
import { underscoredCurrentLocale } from './current_locale'
const availableLocales = window.locales || {}

let jed = null
if (availableLocales[underscoredCurrentLocale]) {
  jed = new Jed(availableLocales[underscoredCurrentLocale])
}

const translate = (phrase, args) => {
  if (!phrase) {
    return ''
  }
  const translatedPhrase = jed ? jed.gettext(phrase) : phrase
  if (args) {
    const sprintfFriendlyPhrase = translatedPhrase.replace(/%{(.+?)}/g, '%($1)s')
    return Jed.sprintf(sprintfFriendlyPhrase, args)
  } else {
    return translatedPhrase
  }
}

const ntranslate = (singularPhrase, pluralPhrase, num, args) => {
  const fallbackPhrase = num == 1 ? singularPhrase : pluralPhrase
  const translatedPhrase = jed ? jed.ngettext(singularPhrase, pluralPhrase, num) : fallbackPhrase
  if (args) {
    const sprintfFriendlyPhrase = translatedPhrase.replace(/%{(.+?)}/g, '%($1)s')
    return Jed.sprintf(sprintfFriendlyPhrase, args)
  } else {
    return translatedPhrase
  }
}

export { translate, translate as __, ntranslate, ntranslate as n__ }
